import {
  FormBody,
  FormContentContainer,
  FormHeader,
  FullScreenLoader,
} from "../../../components";
import { useEffect } from "react";
import { useGetClaveUnicaUrl } from "@hooks/useGetClaveUnicaUrl";

interface Props {
  requestId: string;
  onError: (error: Error) => void;
}

export const ClaveUnicaLogin: React.FC<Props> = ({ requestId, onError }) => {
  const {
    getClaveUnicaUrlMutation: { mutate: getClaveUnicaUrl },
  } = useGetClaveUnicaUrl({ onError });
  useEffect(() => {
    getClaveUnicaUrl({ requestId });
  }, [requestId, getClaveUnicaUrl]);
  return (
    <>
      <FormHeader />
      <FormContentContainer flex={1} disableGutters>
        <FormBody justifyContent="center">
          <FullScreenLoader title={"Verificando tu cédula"} />
        </FormBody>
      </FormContentContainer>
    </>
  );
};
